<div
    class="tw-flex tw-relative"
    [style.width.px]="size()"
    [style.height.px]="size()"
>
    @if (!_faviconLoaded()) {
        <div class="tw-absolute tw-inset-0 placeholder rounded-1"></div>
    }
    <img alt="" [ngSrc]="_faviconSrc()" [height]="size()" [width]="size()" [style.--size.px]="size()" (load)="_faviconLoaded.set(true)" />
</div>
